module.exports = __webpack_public_path__ + "static/formcta-a87dcc0f6321b966c97e4fd270248624.png";